export enum AboEmailUserStatus {
    disabled = 'UNREACHABLE',
    enabled = '',
}